import styled from "styled-components";

const ContactUsStylesStylesContainer = styled.section`
    margin: 0 0 30px;

    .address-details {
        .item {
            .head {
                width: 100px;
            }
        }
    }

    .form-lt,
    .form-rt,
    .form-ct {
        margin-bottom: 20px;
    }
    .form-lt,
    .form-rt {
        width: 50%;
    }
    .form-ct {
        width: 100%;
    }
    .form-lt {
        padding-right: 10px;
    }
    .form-rt {
        padding-left: 10px;
    }

    .default-form-input {
        box-shadow: none !important;
        border-color: #cecece;
        padding-right: 12px;
        height: 40px;
        
        &:focus {
            border-color: #000;
        }

        /* Chrome, Safari, Edge, Opera */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        &[type="number"] {
            -moz-appearance: textfield;
        }
    }

    .form-item.has-error {
        > input,
        > select,
        > textarea {
            border-color: #dc3545;
        }
    }
    .form-item {
        input {
            padding-right: 35px;
        }
        .icon {
            top: 33px;
            right: 10px;
            font-size: 18px;
        }
    }

    .default-btn {
        border: 2px solid #333;
        font-size: 13px;
        padding: 9px 17px;
        background-color: #333;
        color: #fff;
        height: 40px;
        &:hover {
            background-color: #000;
        }
    }
`;

const BreadcrumbsHeaderContainer = styled.div`
    padding-bottom: 20px;
    .heading {
        font-size: 25px;
        font-weight: 800;
        margin-bottom: 5px;
        text-transform: uppercase;
    }
    .link {
        color: #757575;
        transition: 0.2s;
        &:last-child {
            // pointer-events: none;
            font-weight: 600;
        }

        &:hover {
            color: #757575;
        }
    }

    .ec-breadcrumbs {
        color: #757575;
        font-size: 16px;
    }
`;

export { ContactUsStylesStylesContainer, BreadcrumbsHeaderContainer };
